import { NgModule } from '@angular/core';
import { GlobalModule } from '../../global.module';
import { BreakpointComponent } from './breakpoint.component';

@NgModule({
  imports: [GlobalModule, BreakpointComponent],
  exports: [BreakpointComponent],
})
export class BreakpointModule {}
